/**
 * Get responsive styles configuration for the component
 */
export const getResponsiveStyles = () => {
  return {
    containerMinWidth: 1400, // Wider for the additional KCPH column
    dayGroupMinWidth: 180,
    inputWidth: 75,
    inputHeight: 32,
    headerHeight: 48,
    dataRowHeight: 48,
    addZoneMinWidth: 20,
    addZoneMaxWidth: 100,
    kcphMinWidth: 200, // Increased from 120 to 160 for more space
    fontSize: {
      header: 12, // Changed from 14 to 12px
      subHeader: 12,
      input: 12,
    },
    padding: {
      horizontal: 8,
      vertical: 8,
    },
    gap: 8,
    buttonSize: 'small' as const,
  };
};